export default {
  'aplicacioncaja': {
    'version': '0.0.0',
    'hash': '79efe55'
  },
  'allow_switching_backend_instance': true
};